import { Table } from '@devexpress/dx-react-grid-material-ui';
import {
    GivelifyMenu,
    GivelifyTextField,
    GivelifyLabel,
    GivelifyButton,
} from '@givelify/givelify-ui';
import {
    GivelifyNotification,
    GivelifyAvatar,
    GivelifyLegacyColorPalette,
} from '@givelify/ui';
import { styled, Grid, Paper } from '@mui/material';
import { MatchHeaderItem } from '../../../components/style';

export const HomeTabContent = styled(Grid)({
    marginTop: 40,
});

export const DonorItem = styled(Grid)(({ theme }) => ({
    '& > div': {
        marginRight: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            marginRight: 0,
        },
    },
    [theme.breakpoints.down('sm')]: {
        marginBottom: theme.spacing(2),
    },
}));

export const EnvelopeItem = styled(Grid)(({ theme }) => ({
    '& > div': {
        marginLeft: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
        },
    },
}));

export const HomeItemContent = styled('div')(({ theme }) => ({
    height: '100%',
    borderRadius: 10,
    background: GivelifyLegacyColorPalette.primaryWhite,
    boxShadow: '0 0 9px rgba(131, 131, 131, 0.4)',
    padding: theme.spacing(4),
    textAlign: 'center',
}));

export const UnMatchContent = styled('div')({
    marginTop: 56,
});

export const ViewUnMatch = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(4),
}));

export const TotalMatched = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(4),
}));

export const NoUnMatchContent = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(4),
}));

export const MatchedContent = styled('div')({
    marginTop: 24,
});

export const TotalMatchedText = styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
});

export const CenterButton = styled(GivelifyButton)(({ theme }) => ({
    margin: '0 auto',
}));

export const MatchedNumber = styled(GivelifyLabel)(({ theme }) => ({
    fontWeight: 700,
    background: GivelifyLegacyColorPalette.neutralHoverGrey,
    borderRadius: 15,
    padding: theme.spacing(0.5, 1),
    marginRight: theme.spacing(1),
}));

export const Number = styled(GivelifyLabel)(({ theme }) => ({
    fontSize: 48,
    lineHeight: '38px',
    marginBottom: theme.spacing(2),
}));

export const MatchedTitle = styled(GivelifyLabel)({
    textTransform: 'capitalize',
    fontSize: 24,
    fontWeight: 700,
    lineHeight: '32px',
});

export const CaughtUp = styled(GivelifyLabel)(({ theme }) => ({
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(4),
}));

export const MatchNumber = styled(GivelifyLabel)({
    fontSize: 48,
    fontWeight: 600,
    lineHeight: '64px',
});

export const UnMatchedText = styled(GivelifyLabel)({
    fontSize: 16,
    fontWeight: 800,
});

export const UnMatchedTextButton = styled(GivelifyButton)({
    fontSize: 16,
    fontWeight: 800,
});

export const TabLink = styled(GivelifyButton)({
    paddingLeft: 3,
});

export const TotalUnmatchedText = styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    fontSize: 16,
    fontWeight: 800,
});

export const UnmatchHeaderDonorRow = styled('div')({
    fontWeight: 'bold',
});

export const DonorUnmatchName = styled(MatchHeaderItem)({
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '30%',
    minWidth: 200,
});

export const DonorUnmatchNameLabel = styled(GivelifyLabel)({
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

export const DonorContainer = styled(Grid)({
    flexWrap: 'nowrap',
    '& .header-item': {
        display: 'flex',
        height: 54,
        borderBottom: '1px solid ' + GivelifyLegacyColorPalette.neutralPlatinum,
    },
});

export const UnmatchDonation = styled(MatchHeaderItem)({
    width: '20%',
    minWidth: 140,
    borderBottom: '1px solid ' + GivelifyLegacyColorPalette.neutralPlatinum,
});

export const UnmatchNumber = styled(MatchHeaderItem)({
    width: '23%',
    minWidth: 145,
    borderBottom: '1px solid ' + GivelifyLegacyColorPalette.neutralPlatinum,
});

export const UnmatchDate = styled(MatchHeaderItem)({
    width: '27%',
    minWidth: 180,
    borderBottom: '1px solid ' + GivelifyLegacyColorPalette.neutralPlatinum,
});

export const DonorTabContent = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(3),
}));

export const DonorTableContent = styled(Paper)(({ theme }) => ({
    marginTop: theme.spacing(2),
    [theme.breakpoints.between(0, 1113)]: {
        overflow: 'hidden',
        width: '100%',
    },
}));

export const MatchedDonorTableContent = styled(Paper)(({ theme }) => ({
    marginTop: theme.spacing(2),
    [theme.breakpoints.between(0, 1113)]: {
        overflow: 'hidden',
        width: '100%',
    },
}));

export const FilterRow = styled('div')({
    marginRight: 'auto',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
});

export const FilterItem = styled(Grid)(({ theme }) => ({
    marginRight: theme.spacing(4),
}));

export const Selector = styled(GivelifyMenu)(({ theme }) => ({
    minWidth: 160,
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
}));

export const SearchContent = styled(Grid)(({ theme }) => ({
    width: '100%',
    maxWidth: 340,
    [theme.breakpoints.between(0, 1001)]: {
        marginTop: theme.spacing(3),
        marginLeft: 0,
        maxWidth: 352,
    },
}));

export const AutocompleteInput = styled(GivelifyTextField)(({ theme }) => ({
    '& .MuiInputBase-root': {
        border: '1px solid ' + GivelifyLegacyColorPalette.neutralGrey75,
        borderRadius: '25px',
        paddingRight: '16px !important',
        paddingLeft: theme.spacing(2),
        paddingBottom: 0,
        height: 40,
        '&:focus-within': {
            boxShadow: '0 0 0',
        },
    },
    '&:focus': {
        border: 'none',
        outline: 0,
        boxShadow: 'none',
    },
    '& .MuiInputBase-input': {
        paddingLeft: '16px !important',
        '&:focus': {
            outline: 0,
            border: 'none',
            boxShadow: '0 0 0',
        },
    },
    '& svg': {
        fontSize: 16,
    },
}));

export const MatchDonorInfo = styled(Grid)(({ theme }) => ({
    width: 'calc(100% - 137px)',
    '& .donorRow': {
        height: '120px',
    },
    [theme.breakpoints.between(0, 1400)]: {
        width: '100%',

        overflow: 'auto',
    },
}));

export const MatchDonorButton = styled(Grid)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    width: 137,
    flex: '0 0 137px',
    backgroundColor: '#fff',
    [theme.breakpoints.between(0, 976)]: {
        minWidth: 137,
        boxShadow: '-11px 1px 11px 0px #dde2e4',
    },
    [theme.breakpoints.between(0, 1113)]: {
        padding: 0,
    },
}));

export const HeaderButtonItem = styled('div')({
    height: 54,
    width: '100%',
    borderBottom: '1px solid ' + GivelifyLegacyColorPalette.neutralPlatinum,
});

export const HeaderDonorRow = styled('div')({
    fontWeight: 'bold',
    height: 54,
    '& .donorContainer': {
        height: '100%',
    },
});

export const MatchHeaderLogo = styled(MatchHeaderItem)({
    display: 'flex',
    alignItems: 'center',
    minWidth: 72,
    maxWidth: 72,
    '&&': {
        padding: 0,
        justifyContent: 'center',
    },
});

export const MatchDonorName = styled(MatchHeaderItem)(({ theme }) => ({
    minWidth: 193,
    width: 'calc(27% - (72px / 4))',
    [theme.breakpoints.between(0, 1053)]: {
        minWidth: 163,
    },
}));

export const MatchDonorNameHeader = styled(MatchHeaderItem)(({ theme }) => ({
    minWidth: 193,
    width: 'calc(27% - (72px / 4))',
    [theme.breakpoints.between(0, 1053)]: {
        minWidth: 163,
    },
}));

export const MatchDonorEmail = styled(MatchHeaderItem)(({ theme }) => ({
    minWidth: 162,
    width: 'calc(23% - (72px / 4))',
    [theme.breakpoints.between(0, 1053)]: {
        minWidth: 132,
    },
}));

export const MatchDonorPhone = styled(MatchHeaderItem)({
    minWidth: 153,
    width: 'calc(22% - (72px / 4))',
});

export const MatchDonorAddress = styled(MatchHeaderItem)(({ theme }) => ({
    width: 'calc(28% - (72px / 4))',
    minWidth: 201,
    [theme.breakpoints.between(0, 1053)]: {
        minWidth: 167,
    },
}));

export const ButtonItem = styled('div')({
    height: 120,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderBottom: '1px solid ' + GivelifyLegacyColorPalette.neutralPlatinum,
});

export const DonorMatchBtn = styled(GivelifyButton)(({ theme }) => ({
    maxWidth: 114,
    minWidth: 0,
    [theme.breakpoints.between(0, 1399)]: {
        padding: theme.spacing(0, 2),
    },
}));

export const DonorRow = styled('div')({
    width: '100%',
});

export const MatchDonorItem = styled(Grid)(({ theme }) => ({
    padding: theme.spacing(2, 2, 1),
    display: 'flex',
    alignItems: 'center',
    lineHeight: '16px',
    '& > div': {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    },
}));

export const MatchDonorLogo = styled(MatchDonorItem)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRight: '1px solid ' + GivelifyLegacyColorPalette.neutralPlatinum,
    minWidth: 72,
});

export const MatchDonorItemName = styled(MatchDonorItem)(({ theme }) => ({
    minWidth: 193,
    width: 'calc(27% - (72px / 4))',
    [theme.breakpoints.between(0, 1053)]: {
        minWidth: 163,
    },
}));

export const MatchDonorItemEmail = styled(MatchDonorItem)(({ theme }) => ({
    minWidth: 162,
    width: 'calc(23% - (72px / 4))',
    [theme.breakpoints.between(0, 1053)]: {
        minWidth: 132,
    },
}));

export const MatchDonorItemPhone = styled(MatchDonorItem)(({ theme }) => ({
    minWidth: 153,
    width: 'calc(22% - (72px / 4))',
}));

export const MatchDonorItemAddress = styled(MatchDonorItem)(({ theme }) => ({
    width: 'calc(28% - (72px / 4))',
    minWidth: 201,
    [theme.breakpoints.between(0, 1053)]: {
        minWidth: 167,
    },
}));

export const GivelifyLogo = styled('img')(({ theme }) => ({
    [theme.breakpoints.between(0, 1113)]: {
        width: 32,
    },
}));

export const ChmsItemLogo = styled(MatchDonorLogo)(({ theme }) => ({
    height: 64,
    borderBottom: '1px solid ' + GivelifyLegacyColorPalette.neutralPlatinum,
    [theme.breakpoints.between(0, 1113)]: {
        height: 63,
    },
}));

export const ChmsItemName = styled(MatchDonorItemName)(({ theme }) => ({
    height: 64,
    borderBottom: '1px solid ' + GivelifyLegacyColorPalette.neutralPlatinum,
    [theme.breakpoints.between(0, 1113)]: {
        height: 63,
    },
}));

export const ChmsItemEmail = styled(MatchDonorItemEmail)(({ theme }) => ({
    height: 64,
    borderBottom: '1px solid ' + GivelifyLegacyColorPalette.neutralPlatinum,
    [theme.breakpoints.between(0, 1113)]: {
        height: 63,
    },
}));

export const ChmsItemPhone = styled(MatchDonorItemPhone)(({ theme }) => ({
    height: 64,
    borderBottom: '1px solid ' + GivelifyLegacyColorPalette.neutralPlatinum,
    [theme.breakpoints.between(0, 1113)]: {
        height: 63,
    },
}));

export const ChmsItemAddress = styled(MatchDonorItemAddress)(({ theme }) => ({
    height: 64,
    borderBottom: '1px solid ' + GivelifyLegacyColorPalette.neutralPlatinum,
    [theme.breakpoints.between(0, 1113)]: {
        height: 63,
    },
}));

export const GivelifyAvatarWrapper = styled('div')({
    minWidth: 40,
});

export const F1Donor = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
});

export const F1DonorName = styled(GivelifyLabel)({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
});

export const F1DonorId = styled(GivelifyLabel)({
    fontSize: 12,
    lineHeight: '16px',
    color: '#676E77',
});

export const UnmatchDonorInfo = styled(Grid)(({ theme }) => ({
    width: 'calc(100% - 137px)',
    [theme.breakpoints.between(0, 1399)]: {
        overflow: 'auto',
    },
}));

export const UnmatchDonorButton = styled(Grid)(({ theme }) => ({
    width: 137,
    [theme.breakpoints.between(0, 976)]: {
        width: 137,
        minWidth: 137,
        boxShadow: '-11px 1px 11px 0px #dde2e4',
    },
}));

export const UnmatchHeaderDonorButton = styled('div')({
    width: '100%',
    height: 54,
    borderBottom: '1px solid ' + GivelifyLegacyColorPalette.neutralPlatinum,
});

export const UnmatchButtonItem = styled('div')({
    height: 81,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderBottom: '1px solid ' + GivelifyLegacyColorPalette.neutralPlatinum,
});

export const MatchItem = styled(Grid)(({ theme }) => ({
    padding: theme.spacing(3, 2),
    display: 'flex',
    alignItems: 'center',
    lineHeight: '16px',
    [theme.breakpoints.down('sm')]: {
        borderBottom: '1px solid ' + GivelifyLegacyColorPalette.neutralPlatinum,
    },
    '& .matchBtn': {
        maxWidth: 114,
        minWidth: 0,
    },
}));

export const UnmatchDonationItem = styled(MatchItem)({
    width: '20%',
    minWidth: 140,
    borderBottom: '1px solid ' + GivelifyLegacyColorPalette.neutralPlatinum,
});

export const UnmatchDonorName = styled(MatchItem)({
    width: '30%',
    minWidth: 200,
    overflow: 'hidden',
    borderBottom: '1px solid ' + GivelifyLegacyColorPalette.neutralPlatinum,
});

export const UnmatchNumberItem = styled(MatchItem)({
    width: '23%',
    minWidth: 145,
    borderBottom: '1px solid ' + GivelifyLegacyColorPalette.neutralPlatinum,
});

export const UnmatchDateItem = styled(MatchItem)({
    width: '27%',
    minWidth: 180,
    borderBottom: '1px solid ' + GivelifyLegacyColorPalette.neutralPlatinum,
});

export const DonorAvatar = styled(GivelifyAvatar)({
    minWidth: 32,
});

export const DonorNameRow = styled('div')(({ theme }) => ({
    marginLeft: theme.spacing(1),
}));

export const EnvelopeTabContent = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(3),
}));

export const EnvelopeTableContent = styled(Paper)(({ theme }) => ({
    marginTop: theme.spacing(2),
}));

export const ExportedTable = styled(Table.Table)(({ theme }) => ({
    '& > thead': {
        '& tr th': {
            lineHeight: '16px',
            fontSize: 14,
            borderBottom: '1px solid #000000',
            '&.CellLayout-cell': {
                paddingLeft: theme.spacing(0.5),
                paddingRight: theme.spacing(0.5),
                fontWeight: 'normal',
            },
            '&:first-of-type': {
                paddingLeft: `${theme.spacing(2)} !important`,
            },
        },
    },
    '& > tbody': {
        '& tr:hover': {
            background: GivelifyLegacyColorPalette.neutralHoverGrey,
        },
        '& tr td': {
            lineHeight: '16px',
            padding: `${theme.spacing(2, 0.5)} !important`,
            fontSize: 14,
            borderBottom: '1px solid #000000',
            '&:first-of-type': {
                paddingLeft: `${theme.spacing(2)} !important`,
            },
            [theme.breakpoints.down('sm')]: {
                padding: theme.spacing(2),
            },
        },
    },
}));

export const SyncNotification = styled(GivelifyNotification)(({ theme }) => ({
    marginBottom: theme.spacing(5.25),
}));
